import React from 'react';
import classNames from 'classnames'

export const FlexRow = ({children, className}) => {
  return (
    <div className={classNames('flex-row', {[className]: className})}>
      {children}
    </div>
  )
}

export const FlexRowItem = ({children, className, style}) => {
  return (
    <div className={classNames('flex-row__item', {[className]: className})} style={style}>
      {children}
    </div>
  )
}